<template>
	<div>
    <div class="empty-img2" v-if="commentNum==0">
      <img src="./evaluate.png"/>
      <p>暂无评论</p>
    </div>
		<template>
			<div class="score f-cb" v-if="commentNum!=0">
				<div class="score-content">
					<div class="score-content-text">课程评分</div>
					<div class="score-content-scroe">{{score}}</div>
					<star :num="countStar(score)"></star>
					<div class="score-content-num">{{commentNum}}人评分</div>
				</div>
				<div class="score-line"></div>
				<div class="score-stars">
					<ul class="score-stars-items f-cbli">
						<!--<li class="score-stars-item">
							<star :num="4"></star>
							<div class="score-stars-line">
								<div class="score-stars-line-inner"></div>
							</div>
						</li>-->
						<li class="score-stars-item" v-for="(item,value) in scoreData">
							<star :num="5-value"></star>
							<div class="score-stars-line">
								<div class="score-stars-line-inner" :style="{'width':scoreData[value]/commentNum*100+'%'}"></div>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<div class="evaluate">
				<ul class="evaluate-items f-cbli" v-infinite-scroll="loadMore" infinite-scroll-disabled="isLoading" infinite-scroll-distance="10">
					<!--<li class="evaluate-item">
						<div class="evaluate-avatar f-img-box">
							<img src="../index/teacher.png">
						</div>
						<div class="evaluate-content">
							<div class="evaluate-name">老师</div>
							<div class="evaluate-text o3">这节课不错，学的很有收获，这节课不错，学的很有收获这节课不错，学的很有收获这节课不错，学的很有收获这节课不错，学的很有收获这节课不错，学的很有收获</div>
							<div class="evaluate-info f-cb">
								<div class="evaluate-time">2018.07.31 21:19</div>
								<div class="evaluate-fav evaluate-fav-active">123</div>
							</div>
						</div>
					</li>-->
					<li class="evaluate-item" v-for="(item,index) in data">
						<div class="evaluate-avatar f-img-box" @click="$router.push('/other/history/'+item.user_id)">
							<img :src="item.avatar?item.avatar:studentAvatar">
						</div>
						<div class="evaluate-content">
							<div class="evaluate-name" @click="$router.push('/other/history/'+item.user_id)">{{item.nick_name}}</div>
							<div class="evaluate-text o3">{{item.content}}</div>
							<div class="evaluate-info f-cb">
								<div class="evaluate-time">{{tools.timestampConversion(item.create_time)}}</div>
								<div class="evaluate-fav" :class="{'evaluate-fav-active':item.is_like}" @click="fav(index)">{{item.like_num}}</div>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</template>
	</div>
</template>

<script>
	import star from "../star/star.vue"
	import tools from "../../util/tools.js";
	export default{
		data(){
			return {
				data:[],
				commentNum:0,
				score:0,
				scoreData:[],
				isLoading:false,
				page:1,
				isEnd:false
			}
		},
		created(){
      //获取导航参数
      function geturl_j2(name){
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
      }
      var v_key = geturl_j2('v_key');
      if (!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        window.location.href = "/mooc_free_login/video.html?section_id="+ this.$route.params.id +"&course_id="+ this.$route.params.courseId +"&v_key="+ v_key;
      }
			this.$api.get("",{
				api:"/v1/comment/inde",
				course_id:this.$route.params.courseId,
				section_id:this.$route.params.id,
				user_type:this.tools.getCookie("user_type")
			},res => {
				var data=res.data;
				this.commentNum=data.num;
				this.score=data.score;
			})
			this.$api.get("",{
				api:"/v1/comment/getNum",
				course_id:this.$route.params.courseId,
				section_id:this.$route.params.id
			},res => {
				this.scoreData=res.data;
			})
		},
		methods:{
			countStar(score){
				return Math.floor(score/2);
			},
      //初始执行了两次getData是因为在create中获取了一次评分
			getData(){
				var isLoading=this.isLoading;
				if(!isLoading){
					isLoading=true;
					this.$api.get("",{
						api:"/v1/comment/inde",
						course_id:this.$route.params.courseId,
						section_id:this.$route.params.id,
						user_type:this.tools.getCookie("user_type"),
						len:5,
						page:this.page
					},res => {
						var data=res.data.commentList;
						if(data.length<5){
							this.isEnd=true;
						}
						if(data.length>0){
							this.data=this.data.concat(data);
							this.page+=1;
							isLoading=false;
						}
					})
				}
			},
			loadMore(){
				if(this.isEnd) return;
				this.getData();
			},
			fav(index){
				var clickItem=this.data[index];
				this.$api.get("",{
					api:"/v1/comment/like",
					id:clickItem.id,
					user_type:this.tools.getCookie("user_type")
				},res=>{
					clickItem.is_like=1;
					clickItem.like_num+=1;
					this.$toast("点赞成功！");
				})
			}
		},
		components:{
			star
		}
	}
</script>

<style>
	.evaluate-empty{
		padding-top:0.52rem;
		font-size: 0.32rem;
		color:#999;
		text-align: center;
	}
	.score{
		padding:0 0.4rem;
	}
	.score-content{
		float:left;
		padding-top:0.533rem;
	}
	.score-content-text{
		font-size: 0.346rem;
		line-height: 0.346rem;
		color:#999;
	}
	.score-content-scroe{
		margin-top:0.12rem;
		font-size: 0.8rem;
		line-height: 0.8rem;
		color:#333;
	}
	.score-content .star{
		margin-top:0.106rem;
	}
	.score-content-num{
		margin-top:0.226rem;
		font-size: 0.346rem;
		line-height:0.346rem;
		color:#999;
	}
	.score-line{
		float:left;
		margin-left:0.306rem;
		margin-top:0.88rem;
		height:1.466rem;
		width:2px;
		background: #e6e6e6;
	}
	.score-stars{
		float:right;
		padding-top:0.32rem;
		width:6.906rem;
	}
	.score-stars-item{
		margin-top:0.213rem;
	}
	.score-stars .star{
		float:left;
	}
	.score-stars-line{
		float:right;
		overflow: hidden;
		margin-top:0.093rem;
		width:5.093rem;
		height:0.08rem;
		background: #cccccc;
		border-radius: 2px;
	}
	.score-stars-line-inner{
		height:0.08rem;
		background: #ec6d3a;
	}
	.evaluate{
		margin:0.133rem 0.4rem 0 0.4rem;
	}
	.evaluate-item{
		padding-top:0.493rem;
		padding-bottom:0.346rem;
		border-bottom:1px solid #e6e6e6;
	}
	.evaluate-item:last-child{
		border-bottom: 0;
	}
	.evaluate-avatar{
		float:left;
		overflow: hidden;
		width:1.146rem;
		height:1.146rem;
		border-radius: 50%;
	}
	.evaluate-content{
		float:right;
		width:7.8rem;
	}
	.evaluate-name{
		margin-top:0.106rem;
		font-size: 0.426rem;
		line-height:0.426rem;
		color:#333;
	}
	.evaluate-text{
		margin-top:0.333rem;
		font-size: 0.373rem;
		line-height:0.56rem;
		color:#333;
	}
	.evaluate-info{
		margin-top:0.4rem;
		font-size: 0.346rem;
		line-height:0.346rem;
	}
	.evaluate-time{
		float:left;
		color:#999;
	}
	.evaluate-fav{
		float:right;
		padding-left: 0.426rem;
		background: url(fav.png) center left no-repeat;
		background-size: 0.32rem;
	}
	.evaluate-fav-active{
		background-image: url(fav-active.png);
		color:#ff3939;
	}
</style>



// WEBPACK FOOTER //
// src/components/lesson-evaluate/lesson-evaluate.vue